import AGENCY_API from 'api/agency/'
import AGENCY_API_V1 from 'api/agency/v1'
import { push } from 'connected-react-router'
import { startSubmit, stopSubmit } from 'redux-form'
import { call, put, select, takeEvery, takeLatest } from 'redux-saga/effects'
import { cancellableCall } from 'store/saga-utils/cancellableCall.saga'
import extractViolations from 'utils/extractViolations'
import { ROUTES } from 'constants/routes'
import { generatePath } from 'react-router'
import { notificationShow } from 'modules/Notifications/actions'

function* fetchClients({ payload }) {
  const { pagination, data: currentData } = yield select(
    (state) => state['agency/clients'],
  )

  yield put({
    type: 'AGENCY/CLIENTS_TOGGLE_LOADING',
    payload: { loading: true },
  })

  try {
    const { response, error, canceled } = yield cancellableCall(
      AGENCY_API_V1.fetchClients,
      {
        params: payload.params,
      },
      arguments,
    )

    if (canceled) return

    if (error) {
      throw error
    }

    const {
      data,
      pagination: { total },
    } = response

    yield put({
      type: 'AGENCY/CLIENTS_SET_DATA',
      payload: {
        data: currentData.concat(data),
        pagination: {
          ...pagination,
          total,
        },
      },
    })
  } catch (error) {
    yield put({ type: 'AGENCY/CLIENTS_LOAD_DATA_FAILED' })
    console.logXHR(error)
  } finally {
    yield put({
      type: 'AGENCY/CLIENTS_TOGGLE_LOADING',
      payload: { loading: false },
    })
  }
}

function* toggleClientArchive({ payload: { ids, action } }) {
  const { filters } = yield select((state) => state['agency/clients'])

  try {
    yield put({
      type: 'AGENCY/CLIENT_UPDATE',
      payload: { id: ids[0], update: { processing: true } },
    })

    const { error } = yield call(
      action === 'archive'
        ? AGENCY_API_V1.archiveClients
        : AGENCY_API_V1.activateClients,
      {
        data: {
          ids,
        },
      },
    )

    if (error) {
      throw error
    }

    yield put({
      type: 'AGENCY/CLIENT_UPDATE',
      payload: {
        id: ids[0],
        update: {
          processing: false,
          state: action === 'archive' ? 'archive' : 'active',
        },
      },
    })

    if (
      (action === 'archive' && filters.status !== 'archived') ||
      (action === 'activate' && filters.status === 'archived')
    ) {
      yield put({
        type: 'AGENCY/CLIENTS_LIST_REMOVE_ITEM',
        payload: { id: ids[0] },
      })
    }

    yield put(
      notificationShow({
        type: 'success',
        message: `agency::notifications.${action}.success`,
      }),
    )
  } catch (error) {
    yield put({
      type: 'AGENCY/CLIENT_UPDATE',
      payload: {
        id: ids[0],
        update: { processingFailed: true, processing: false },
      },
    })

    yield put(
      notificationShow({
        type: 'error',
        message: `agency::notifications.${action}.error`,
      }),
    )

    console.logXHR(error)
  }
}

function* transferToClient({ payload }) {
  const { i18n } = yield select(({ app }) => app)
  
  try {
    yield put(startSubmit('TransferToClient'))
    const { error } = yield call(AGENCY_API.transfer, {
      clientId: payload.id,
      data: payload.data,
    })

    if (error) {
      throw error
    }

    yield put(push(generatePath(ROUTES.AGENCY_CLIENTS, { i18n })))
  } catch (error) {
    yield put(stopSubmit('TransferToClient', extractViolations(error)))
    console.logXHR(error)
  }
}

function* setPriority({ payload: { id, priority } }) {
  try {
    // не уверен надо ли тут вообще заниматься хэндлингом неуспешных изменений приоритета.
    const { error } = yield call(AGENCY_API_V1.setPriority, {
      data: {
        ids: [id],
        priority,
      },
    })

    if (error) {
      throw error
    }

    yield put({
      type: 'AGENCY/CLIENT_UPDATE',
      payload: { id, update: { priority } },
    })
  } catch (error) {
    console.logXHR(error)
  }
}

function* renameClient({ payload: { id, data } }) {
  try {
    yield put({
      type: 'AGENCY/CLIENT_UPDATE',
      payload: { id, update: { processing: true } },
    })

    const { error } = yield call(AGENCY_API_V1.renameClient, {
      id,
      data,
    })

    if (error) {
      throw error
    }

    yield put({
      type: 'AGENCY/CLIENT_UPDATE',
      payload: { id, update: { name: data.name, processing: false } },
    })
  } catch (error) {
    yield put({
      type: 'AGENCY/CLIENT_UPDATE',
      payload: { id, update: { processingFailed: true } },
    })

    yield put(
      notificationShow({
        type: 'error',
        message: 'common::notifications.data_update_failed',
      }),
    )

    console.logXHR(error)
  }
}

export default function* Sagas() {
  yield takeLatest('AGENCY/CLIENTS_FETCH', fetchClients)
  yield takeEvery('AGENCY/TOGGLE_CLIENT_ARCHIVE', toggleClientArchive)
  yield takeEvery('AGENCY/FORMS_TRANSFER_TO_CLIENT', transferToClient)
  yield takeEvery('AGENCY/CLIENT_SET_PRIORITY', setPriority)
  yield takeLatest('AGENCY/CLIENT_RENAME', renameClient)
}
